import React from 'react';
import './App.css';
import Navbar from './Components/1-Navbar/index';
import Landing from './Components/2-Landing/index';
import Services from './Components/3-Services';
import Footer from './Components/4-Footer';

function App() {

  return (
    <div className="App">
      {/* <Whatsapp /> */}
      <Navbar />
      <Landing />
      <Services />
      <Footer />
    </div>
  );
}

export default App;